import { render, staticRenderFns } from "./ForcedDisplayNameDialog.vue?vue&type=template&id=650bdb97&scoped=true"
import script from "./ForcedDisplayNameDialog.vue?vue&type=script&lang=js"
export * from "./ForcedDisplayNameDialog.vue?vue&type=script&lang=js"
import style0 from "./ForcedDisplayNameDialog.vue?vue&type=style&index=0&id=650bdb97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650bdb97",
  null
  
)

export default component.exports